import { Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { chainsListPageTitleTranslation } from './translation';
import { useChainsListPageTitleStyles } from './useChainsListPageTitleStyles';

export const ChainsListPageTitle = () => {
  const { classes } = useChainsListPageTitleStyles();
  const { keys, t } = useTranslation(chainsListPageTitleTranslation);

  return (
    <Typography className={classes.root} color="textPrimary" variant="h5">
      {t(keys.title)}
    </Typography>
  );
};
